import axios from 'axios'
import { Globals } from '../Globals'

const ApiService = {
  activateUser(activationCode, payload) {
    return axios({
      url: `${Globals.API_URL}/api/activate/${activationCode}`,
      method: "POST",
      data: payload,
    });
  },
  registerUser(name, email) {
    return axios({
      url: `${Globals.API_URL}/api/register`,
      method: "POST",
      data: {
        name: name,
        email: email
      },
    });
  },
  changeCurrency(currency) {
    return axios({
      url: `${Globals.API_URL}/api/currency/${currency}`,
      method: "POST",
    });
  },
  changeLang(lang) {
    return axios({
      url: `${Globals.API_URL}/api/lang/${lang}`,
      method: "GET",
    });
  },
  createUser(tenantID, name, email, language = 'no', currency = 'NOK') {
    return axios({
      url: `${Globals.API_URL}/api/admin/create-user`,
      method: "POST",
      data: {
        tenantID: tenantID,
        name: name,
        email: email,
        language: language,
        currency: currency
      }
    });
  },
  generateMeltwaterMetrics() {
    return axios({
      url: `${Globals.API_URL}/api/admin/generate-meltwater-metrics`,
      method: "POST",
    });
  },
  getAccessTokens() {
    return axios({
      url: `${Globals.API_URL}/api/admin/access-tokens`,
      method: "GET",
    });
  },
  getActivationUser(activationCode) {
    return axios({
      url: `${Globals.API_URL}/api/activate/${activationCode}`,
      method: "GET",
    });
  },
  getAllTenants() {
    return axios({
      url: `${Globals.API_URL}/api/admin/all-tenants`,
      method: "GET",
    });
  },
  getTenantsSocialStatus() {
    return axios({
      url: `${Globals.API_URL}/api/admin/tenants-social-status`,
      method: "GET",
    });
  },
  getAllUsers() {
    return axios({
      url: `${Globals.API_URL}/api/admin/all-users`,
      method: "GET",
    });
  },
  getBrandPressCount(since, until, params) {
    return axios({
      url: `${Globals.API_URL}/api/brand/count?since=${since}&until=${until}`,
      method: "GET",
      params,
    });
  },
  getBrandSentiment(since, until) {
    return axios({
      url: `${Globals.API_URL}/api/brand/sentiment?since=${since}&until=${until}`,
      method: "GET",
    });
  },
  getBrandSources(since, until) {
    return axios({
      url: `${Globals.API_URL}/api/brand/sources?since=${since}&until=${until}`,
      method: "GET",
    });
  },
  getCurrencyConversion() {
    return axios({
      url: `${Globals.API_URL}/api/currency_conversions`,
      method: "GET",
    });
  },

  getDemographics(since, until) {
    return axios({
      url: `${Globals.API_URL}/api/demographics?since=${since}&until=${until}`,
    });
  },
  getPartnerEngagementValue(partnerId = "", selectedTenantId = "", since, until, tracked = false) {
    return axios({
      url: `${Globals.API_URL}/api/partners/engagement/value?partnerId=${partnerId}&selectedTenantId=${selectedTenantId}&since=${since}&until=${until}${tracked ? "&tracked=1" : ""}`,

      method: "GET",
    });
  },
  getPartnerSumDivided(partnerId = "", selectedTenantId = "", since, until) {
    return axios({
      url: `${Globals.API_URL}/api/partners/sum-divided-value?partnerId=${partnerId}&selectedTenantId=${selectedTenantId}&since=${since}&until=${until}`,
      method: "GET",
    });
  },
  getProfileData() {
    return axios({
      url: `${Globals.API_URL}/api/person/meta-profile-data`,
      method: "GET",
    });
  },
  setProfileData(formData) {
    return axios({
      url: `${Globals.API_URL}/api/person/meta-profile-data`,
      method: "POST",
      data: formData,
    });
  },
  getDemographicsByLeague(overrideTenantId, since, until) {
    return axios({
      url: `${Globals.API_URL}/api/demographics/league?since=${since}&until=${until}&overrideTenantId=${overrideTenantId}`,
      method: "GET",
    });
  },
  getPartnerReachValue(partnerId = "", selectedTenantId = "", since, until, tracked = false) {
    return axios({
      url: `${Globals.API_URL}/api/partners/reach/value?partnerId=${partnerId}&selectedTenantId=${selectedTenantId}&since=${since}&until=${until}${tracked ? "&tracked=1" : ""}`,
      method: "GET",
    });
  },
  getEngagement(overrideTenantId, since, until) {
    return axios({
      url: `${Globals.API_URL}/api/engagement?since=${since}&until=${until}&overrideTenantId=${overrideTenantId}`,
      method: "GET",
    });
  },
  getEngagementChannels(since, until) {
    return axios({
      url: `${Globals.API_URL}/api/engagement-channels?since=${since}&until=${until}`,
      method: "GET",
    });
  },
  getExportedReport(type, format, since, until, partners, sponsorObjects) {
    const url = new URL(`${Globals.API_URL}/api/reports/export`);
    const params = new URLSearchParams({
      type,
      format,
      since,
      until,
    });

    if (partners) {
      params.append('partners', partners);
    }

    if (sponsorObjects) {
      params.append('sponsorObjects', sponsorObjects);
    }

    url.search = params.toString();
    const finalUrl = url.toString();

    return axios({
      url: finalUrl,
      method: "GET",
      responseType: "blob",
    });
  },
  getSocialPostsPerformance(orderBy, orderByDirection, since, until) {
    return axios({
      url: `${Globals.API_URL}/api/social/posts`,
      params: {
        orderBy,
        orderByDirection,
        since,
        until,
      },
      method: "GET",
    });
  },
  getFacebookPostsPerformance(sort, since, until) {
    return axios({
      url: `${Globals.API_URL}/api/social/posts/facebook?sort=${sort}&posts=10&since=${since}&until=${until}`,
      method: "GET",
    });
  },
  getFollowerGeography() {
    return axios({
      url: `${Globals.API_URL}/api/geography`,
      method: "GET",
    });
  },
  getFollowers(since, until, averages) {
    return axios({
      url: `${Globals.API_URL}/api/person/followers?since=${since}&until=${until}&average=${averages}`,
      method: "GET",
    });
  },
  getInstagramPostsPerformance(sort, since, until) {
    return axios({
      url: `${Globals.API_URL}/api/social/posts/instagram?sort=${sort}&posts=10&since=${since}&until=${until}`,
      method: "GET",
    });
  },
  getLang() {
    return axios({
      url: `${Globals.API_URL}/api/lang/getLanguage`,
      method: "GET",
    });
  },
  getLeagueTable(table, since, until, overrideTenantId) {
    return axios({
      url: `${Globals.API_URL}/api/league/${table}?since=${since}&until=${until}&overrideTenantId=${overrideTenantId}`,
      method: "GET",
    });
  },
  getLeagueClubFollowers(since, until) {
    return axios({
      url: `${Globals.API_URL}/api/league/followers?since=${since}&until=${until}`,
      method: "GET",
    });
  },
  getMetaProfile() {
    return axios({ url: `${Globals.API_URL}/api/person/meta-profile-data`, method: "GET" });
  },
  getMetric(metric, params, since, until) {
    return axios({
      url: `${Globals.API_URL}/api/metric/${metric}?since=${since}&until=${until}`,
      method: "GET",
      params,
    });
  },
  getNextMatch() {
    return axios({ url: `${Globals.API_URL}/api/matches/next`, method: "GET" });
  },
  getPageAccessTokens() {
    return axios({
      url: `${Globals.API_URL}/api/admin/page-access-tokens`,
      method: "GET",
    });
  },
  getPartnerActive() {
    return axios({
      url: `${Globals.API_URL}/api/partners/active`,
      method: "GET",
    });
  },
  getPartnerDividedEngagement(since, until) {
    return axios({
      url: `${Globals.API_URL}/api/partners/engagement/divided?since=${since}&until=${until}`,
      method: "GET",
    });
  },
  getPartnerDividedReach(partnerId = "", selectedTenantId = "", since, until, tracked = false) {
    return axios({
      url: `${Globals.API_URL}/api/partners/reach/divided?partnerId=${partnerId}&selectedTenantId=${selectedTenantId}&since=${since}&until=${until}${tracked ? "&tracked=1" : ""}`,
      method: "GET",
    });
  },
  getPartnerDividedMedia(partnerId = "", since, until) {
    return axios({
      url: `${Globals.API_URL}/api/partners/media/divided`,
      method: "GET",
      params: {
        partnerId,
        since,
        until,
      },
    });
  },
  getPartnerDividedValue(partnerId = "",selectedTenantId = "", since, until, tracked = false) {
    return axios({
      url: `${Globals.API_URL}/api/partners/value/divided?partnerId=${partnerId}&selectedTenantId=${selectedTenantId}&since=${since}&until=${until}${tracked ? "&tracked=1" : ""}`,
      method: "GET",
    });
  },
  getPartnerEngagement(partnerId = "", selectedTenantId = "", since, until, tracked = false) {
    return axios({
      url: `${Globals.API_URL}/api/partners/engagement?partnerId=${partnerId}&selectedTenantId=${selectedTenantId}&since=${since}&until=${until}${tracked ? "&tracked=1" : ""}`,
      method: "GET",
    });
  },
  getPartnerReach(partnerId = "", selectedTenantId = "", since, until, tracked = false) {
    return axios({
      url: `${Globals.API_URL}/api/partners/reach?partnerId=${partnerId}&selectedTenantId=${selectedTenantId}&since=${since}&until=${until}${tracked ? "&tracked=1" : ""}`,
      method: "GET",
    });
  },
  getPartnerValue(since, until) {
    return axios({
      url: `${Globals.API_URL}/api/partners/value?since=${since}&until=${until}`,
      method: "GET",
    });
  },
  getPartnerValuePerPartner(selectedTenantId = "", partnerId = "", since, until, tracked = false) {
    return axios({
      url: `${Globals.API_URL}/api/partners/partners?selectedTenantId=${selectedTenantId}&partnerId=${partnerId}&since=${since}&until=${until}${tracked ? "&tracked=1" : ""}`,
      method: "GET",
    });
  },
  getPartnerValuePerSource(partnerId = "", selectedTenantId = "", since, until, tracked = false) {
    return axios({
      url: `${Globals.API_URL}/api/partners/sources?partnerId=${partnerId}&selectedTenantId=${selectedTenantId}&since=${since}&until=${until}${tracked ? "&tracked=1" : ""}`,
      method: "GET",
    });
  },
  getPartnerValuePerStation(partnerId = "", selectedTenantId = "", since, until) {
    return axios({
      url: `${Globals.API_URL}/api/partners/stations?partnerId=${partnerId}&selectedTenantId=${selectedTenantId}&since=${since}&until=${until}`,
      method: "GET",
    });
  },
  getPartners() {
    return axios({
      url: `${Globals.API_URL}/api/partners`,
      method: "GET",
    });
  },
  getProjects() {
    return axios({
      url: `${Globals.API_URL}/api/projects`,
      method: "GET",
    });
  },

  getPotentialTickets() {
    return axios({
      url: `${Globals.API_URL}/api/matches/potential`,
      });
  },
  getSponsorDividedReach(sponsorObjectId, since, until, tracked = false) {
    return axios({
      url: `${Globals.API_URL}/api/sponsors/reach/divided?since=${since}&until=${until}`,
      method: "GET",
      params: { sponsorObjectId, ...(tracked ? { tracked: 1 } : {}) },
    });
  },
  getSponsorDividedEngagement(sponsorObjectId, since, until, tracked = false) {
    return axios({
      url: `${Globals.API_URL}/api/sponsors/engagement/divided?since=${since}&until=${until}`,
      method: "GET",
      params: { sponsorObjectId, ...(tracked ? { tracked: 1 } : {}) },
    });
  },
  getSponsorDividedEngagementValue(sponsorObjectId, since, until, tracked = false) {
    return axios({
      url: `${Globals.API_URL}/api/sponsors/engagement/divided/value?since=${since}&until=${until}`,
      method: "GET",
      params: { sponsorObjectId, ...(tracked ? { tracked: 1 } : {}) },
    });
  },
  getSocialMediaState() {
    return axios({
      url: `${Globals.API_URL}/api/person/dashboard/social-metrics/status`,
      method: "GET",
    });
  },
  async setSocialMediaState(formData) {
    return axios({
      url: `${Globals.API_URL}/api/person/dashboard/social-metrics/status`,
      method: "POST",
      data: formData,
    });
  },
  async getBoxedMetrics(metric, since, until) {
    return axios({
      url: `${Globals.API_URL}/api/person/dashboard/boxed-metrics?metric=${metric}&since=${since}&until=${until}`,
      method: "GET",
    });
  },
  async getAthleteMetric(metric, since, until) {
    return axios({
      url: `${Globals.API_URL}/api/person/dashboard/athlete-metrics?metric=${metric}&since=${since}&until=${until}`,
      method: "GET",
    });
  },
  async getMediaValuePeriod(since, until) {
    return axios({
      url: `${Globals.API_URL}/api/person/media-value-period`,
      method: "GET",
      params: { since, until}
    });
  },
  async getReachValuePeriod(since, until) {
    return axios({
      url: `${Globals.API_URL}/api/person/reach-value-period`,
      method: "GET",
      params: { since, until },
    });
  },
  async getEngagementValuePeriod(since, until) {
    return axios({
      url: `${Globals.API_URL}/api/person/engagement-value-period`,
      method: "GET",
      params: { since, until },
    });
  },
  async getSponsorsValue(since, until) {
    return axios({
      url: `${Globals.API_URL}/api/person/sponsors-value`,
      method: "GET",
      params: { since, until },
    });
  },
  async getAthleteAudienceFollowerGeography() {
    return axios({
      url: `${Globals.API_URL}/api/person/audience/geography`,
      method: "GET",
    });
  },

  async getAudienceInsights(comparisonCodes = []) {
    return axios({
      url: `${Globals.API_URL}/api/audience-insights`,
      method: "GET",
      params: {
        comparison: comparisonCodes[0] || null
      }
    });
  },

  async getAudienceInsightsBrandAssociations(brandId = null, comparisonId = null, audienceType = 'brand_recognizers') {
    return axios({
      url: `${Globals.API_URL}/api/audience-insights/brands${brandId ? `/${brandId}` : ''}`,
      method: "GET",
      params: {
        comparison: comparisonId,
        audience_type: audienceType
      }
    });
  },

  async getAudienceInsightsBrandRecognition(brandId = null, comparisonId = null, audienceType = 'brand_recognizers') {
    return axios({
      url: `${Globals.API_URL}/api/audience-insights/recognition`,
      method: "GET",
      params: {
        brand: brandId,
        comparison: comparisonId,
        audience_type: audienceType
      }
    });
  },

  async getAudienceInsightsDemographics(comparisonId = null, audienceType = 'brand_recognizers') {
    return axios({
      url: `${Globals.API_URL}/api/audience-insights/demographics`,
      method: "GET",
      params: {
        comparison: comparisonId,
        audience_type: audienceType
      }
    });
  },

  async getAudienceInsightsEngagementChannels(comparisonId = null, audienceType = 'brand_recognizers') {
    return axios({
      url: `${Globals.API_URL}/api/audience-insights/engagement/channels`,
      method: "GET",
      params: {
        comparison: comparisonId,
        audience_type: audienceType
      }
    });
  },

  async getAudienceInsightsFilterOptions() {
    return axios({
      url: `${Globals.API_URL}/api/audience-insights/filter-options`,
      method: "GET"
    });
  },

  async getAudienceInsightsGeographyBase(audienceType = 'brand_recognizers') {
    return axios({
      url: `${Globals.API_URL}/api/audience-insights/geography/base`,
      method: "GET",
      params: { audience_type: audienceType }
    });
  },

  async getAudienceInsightsGeographyCompare(comparisonId, audienceType = 'brand_recognizers') {
    return axios({
      url: `${Globals.API_URL}/api/audience-insights/geography/compare/${comparisonId}`,
      method: "GET",
      params: { audience_type: audienceType }
    });
  },
  getSoldTickets(since, until) {
    return axios({
      url: `${Globals.API_URL}/api/matches/tickets?since=${since}&until=${until}&reverse=false`,
      method: "GET",
    });
  },
  getSponsorDividedValue(sponsorObjectId, since, until, tracked = false) {
    return axios({
      url: `${Globals.API_URL}/api/sponsors/value/divided?since=${since}&until=${until}`,
      method: "GET",
      params: { sponsorObjectId, ...(tracked ? { tracked: 1 } : {}) },
    });
  },
  getSponsorDividedValueYear(sponsorObjectId, partnerId, since, until) {
    return axios({
      url: `${Globals.API_URL}/api/sponsors/value/divided/this-year`,
      method: "GET",
      params: {
        sponsorObjectId,
        partnerId,
        since,
        until,
      },
    });
  },
  /* Unsure why this is here. Duplicate name: getSponsorValuePerStation(sponsorObjectId, since, until) {
    return axios({
      url: `${Globals.API_URL}/api/sponsors/reach/divided?since=${since}&until=${until}`,
      method: "GET",
      params: { sponsorObjectId }
          });
  }, */
  getSponsorLogoStats(sponsorObjectId, since, until) {
    return axios({
      url: `${Globals.API_URL}/api/sponsors/logostats?since=${since}&until=${until}`,
      method: "GET",
      params: { sponsorObjectId }
          });
  },
  getSponsorObjects(sponsorObjectId) {
    return axios({
      url: `${Globals.API_URL}/api/sponsors/objects`,
      method: "GET",
      params: { sponsorObjectId }
          });
  },
  getSponsorReach(sponsorObjectId, since, until, tracked = false) {
    return axios({
      url: `${Globals.API_URL}/api/sponsors/reach?since=${since}&until=${until}`,
      method: "GET",
      params: { sponsorObjectId, ...(tracked ? { tracked: 1 } : {}) }
          });
  },
  getSponsorValue(sponsorObjectId, since, until, tracked = false) {
    return axios({
      url: `${Globals.API_URL}/api/sponsors/value?since=${since}&until=${until}`,
      method: "GET",
      params: { sponsorObjectId, ...(tracked ? { tracked: 1 } : {}) }
          });
  },
  getSponsorMediaValue(sponsorObjectId, since, until) {
    return axios({
      url: `${Globals.API_URL}/api/sponsors/media-value`,
      method: "GET",
      params: { sponsorObjectId, since, until, tracked: 1 },
    });
  },
  getSponsorEngagementValue(sponsorObjectId, since, until) {
    return axios({
      url: `${Globals.API_URL}/api/sponsors/engagement-value`,
      method: "GET",
      params: { sponsorObjectId, since, until, tracked: 1 },
    });
  },
  getSponsorValuePerSource(sponsorObjectId) {
    return axios({
      url: `${Globals.API_URL}/api/sponsors/sources`,
      method: "GET",
      params: { sponsorObjectId }
          });
  },
  getSponsorValuePerStation(sponsorObjectId, since, until) {
    return axios({
      url: `${Globals.API_URL}/api/sponsors/stations?since=${since}&until=${until}`,
      method: "GET",
      params: { sponsorObjectId }
          });
  },
  getStadiumSellOut() {
    return axios({
      url: `${Globals.API_URL}/api/stadium-sell-out`,
      method: "GET",
    });
  },
  getTVJobs() {
    return axios({
        url: `${Globals.API_URL}/api/admin/tv-jobs`,
        method: "GET",
    });
  },
  getTenants() {
    return axios({
      url: `${Globals.API_URL}/api/tenants`,
      method: "GET"
    });
  },
  getTest(name) {
    return axios({
      url: `${Globals.API_URL}/api/test/${name}`,
      method: "GET",
    });
  },
  getTicketsNextMatch() {
    return axios({
      url: `${Globals.API_URL}/api/matches/tickets-next-match`,
      method: "GET",
    });
  },
  getTvEngagement(since, until) {
    return axios({
      url: `${Globals.API_URL}/api/tv/engagement?since=${since}&until=${until}`,
      method: "GET",
    });
  },
  getTvViewers(since, until) {
    return axios({
      url: `${Globals.API_URL}/api/matches/viewers?since=${since}&until=${until}`,
      method: "GET",
    });
  },
  getSponsorTvDivided(since, until, sponsorObjectId) {
    return axios({
      url: `${Globals.API_URL}/api/sponsors/tv-divided?since=${since}&until=${until}`,
      method: "GET",
      params: { sponsorObjectId }
    });
  },
  getSponsorLogoPlacementAnalysis(since, until, sponsorObjectId) {
    return axios({
      url: `${Globals.API_URL}/api/sponsors/logo-placement-analysis?since=${since}&until=${until}`,
      method: "GET",
      params: { sponsorObjectId }
    });
  },
  getMarketAnalysis(since, until, sponsorObjectId) {
    return axios({
      url: `${Globals.API_URL}/api/sponsors/market-analysis?since=${since}&until=${until}`,
      method: "GET",
      params: { sponsorObjectId }
    });
  },
  getSponsorValueBreakdown(since, until, mode, drilldown) {
    return axios({
      url: `${Globals.API_URL}/api/sponsors/value-breakdown`,
      method: "GET",
      params: { since, until, mode, drilldown }
    });
  },
  getSponsorValueBreakdownDetails(since, until, channels, markets, rights, page, perPage, sortBy, sortOrder) {
    return axios({
      url: `${Globals.API_URL}/api/sponsors/value-breakdown-details`,
      method: "GET",
      params: {
        since,
        until,
        channels: channels?.join(','),
        markets: markets?.join(','),
        rights: rights?.join(','),
        page,
        per_page: perPage,
        sort_by: sortBy,
        sort_order: sortOrder
      }
    });
  },
  getUser() {
    return axios({ url: `${Globals.API_URL}/api/user`, method: "GET" });
  },
  getUserCurrency() {
    return axios({
      url: `${Globals.API_URL}/api/currency`,
      method: "GET",
    });
  },
  getVisibility(overrideTenantId, since, until) {
    return axios({
      url: `${Globals.API_URL}/api/visibility?since=${since}&until=${until}&overrideTenantId=${overrideTenantId}`,
      method: "GET",
    });
  },
  getWordcloud(since, until) {
    return axios({
      url: `${Globals.API_URL}/api/brand/wordcloud?since=${since}&until=${until}`,
      method: "GET",
    });
  },
  importMeltwater(formData) {
    return axios({
      url: `${Globals.API_URL}/api/admin/import-meltwater`,
      method: "POST",
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
      }    
    });
    },
  importTV(formData) {
    return axios({
      url: `${Globals.API_URL}/api/admin/import-tv`,
      method: "POST",
      data: formData,
      headers: {
          "Content-Type": "multipart/form-data",
      }    
    });
  },
  importMedietall(formData) {
    return axios({
      url: `${Globals.API_URL}/api/admin/import-medietall`,
      method: "POST",
      data: formData,
      headers: {
          "Content-Type": "multipart/form-data",
      }
    });
  },
  meltwaterJobsCount() {
    return axios({
      url: `${Globals.API_URL}/api/admin/jobs/meltwater`,
      method: "GET",
    });
  },
  removeUser(userID, name, email) {
    return axios({
      url: `${Globals.API_URL}/api/admin/remove-user?userID=${userID}&name=${name}&email=${email}`,
      method: "POST",
    });
  },
  runFacebookJobs(page, post, insight, stats) {
    return axios({
      url: `${Globals.API_URL}/api/admin/facebook-jobs?page=${page}&post=${post}&insight=${insight}&stats=${stats}`,
      method: "POST",
    });
  },
  runInstagramJobs(post, insight, stats) {
    return axios({
      url: `${Globals.API_URL}/api/admin/instagram-jobs?post=${post}&insight=${insight}&stats=${stats}`,
      method: "POST",
    });
  },
  runOverallMetricsJob() {
    return axios({
      url: `${Globals.API_URL}/api/admin/overall-metrics-job`,
      method: "POST",
    });
  },
  updateTVMetrics() {
    return axios({
        url: `${Globals.API_URL}/api/admin/update-tv-metrics`,
        method: "POST",
    });
  },
  getMergedTenants() {
    return axios({
      url: `${Globals.API_URL}/api/partners/merged-tenants`,
      method: "GET",
    });
  },
  getPerformanceIndex() {
    return axios({
      url: `${Globals.API_URL}/api/person/performance-index`,
    });
  },
  getSocialMediaPost(media, postId) {
    return axios({
      url: `${Globals.API_URL}/api/social/posts/${media}/${postId}`,
      method: "GET",
    });
  },
  getPerformingSocialMediaPosts(since, until, orderBy, orderDirection, params = {}) {
    return axios({
      url: `${Globals.API_URL}/api/social/posts/performing`,
      method: "GET",
      params: {
        since,
        until,
        orderBy,
        orderDirection,
        ...params,
      },
    });
  },
  getPerformingSocialMediaMentions(since, until, orderBy, orderDirection) {
    return axios({
      url: `${Globals.API_URL}/api/social/mentions/performing?since=${since}&until=${until}&orderBy=${orderBy}&orderDirection=${orderDirection}`,
      method: "GET",
    });
  },
  getPerformingSocialMediaTagged(since, until, orderBy, orderDirection) {
    return axios({
      url: `${Globals.API_URL}/api/social/tagged/performing?since=${since}&until=${until}&orderBy=${orderBy}&orderDirection=${orderDirection}`,
      method: "GET",
    });
  },
  getParnterImageDetectionExample(partnerId, sponsorObjectId) {
    return axios({
      url: `${Globals.API_URL}/api/partners/image-detection-example`,
      params: {
        partnerId,
        sponsorObjectId
      },
      method: "GET",
    });
  },
  getSponsorImageDetectionExample(sponsorObjectId) {
    return axios({
      url: `${Globals.API_URL}/api/sponsors/image-detection-example`,
      params: {
        sponsorObjectId
      },
      method: "GET",
    });
  },
  getPersonSocialMetrics() {
    return axios({
      url: `${Globals.API_URL}/api/person/dashboard/social-metrics`,
      method: "GET",
    })
  },
  getPersonSocialTimeline(since, until) {
    return axios({
      url: `${Globals.API_URL}/api/person/dashboard/social-timeline`,
      method: "GET",
      params: {since, until}
    })
  },
  getPostOverview(since, until) {
    return axios({
      url: `${Globals.API_URL}/api/social/posts/overview`,
      method: "GET",
      params: {since, until}
    })
  },
  getPostComments(provider, id) {
    return axios({
      url: `${Globals.API_URL}/api/social/posts/${provider}/${id}/comments`,
      method: "GET",
    })
  },
  postComment(comment) {
    return axios({
      url: `${Globals.API_URL}/api/person/dashboard/social-timeline`,
      method: "POST",
      data: comment
    })
  },
  getTenantProfileData() {
    return axios({
      url: `${Globals.API_URL}/api/person/meta-profile-data`,
      method: "GET",
    })
  },
  getAllBrands() {
    return axios({
      url: `${Globals.API_URL}/api/brand/all`,
      method: 'GET',
    });
  },
  setSponsors(brandIds) {
    return axios({
      url: `${Globals.API_URL}/api/brand/tenant`,
      method: 'POST',
      data: {brandIds},
    });
  },
  getSponsorContracts() {
    return axios({
      url: `${Globals.API_URL}/api/sponsor-contracts`,
      method: 'GET',
    });
  },
  createSponsorContract(formData) {
    return axios({
      url: `${Globals.API_URL}/api/sponsor-contracts`,
      method: 'POST',
      data: formData,
    });
  },
  updateSponsorContract(contractId, formData) {
    return axios({
      url: `${Globals.API_URL}/api/sponsor-contracts/${contractId}`,
      method: 'PUT',
      data: formData,
    });
  },
  deleteSponsorContract(contractId) {
    return axios({
      url: `${Globals.API_URL}/api/sponsor-contracts/${contractId}`,
      method: 'DELETE',
    });
  },
  getTenantBrands() {
    return axios({
      url: `${Globals.API_URL}/api/brand-tenants`,
      method: "GET",
    })
  },
  getSponsorROI(since, until, sponsorObjectId, usePaValue = false, rightsholderId = 0, parentTenantId = null, tracked = false) {
    return axios({
      url: `${Globals.API_URL}/api/sponsor-contracts/roi?since=${since}&until=${until}`,
      params: {
        sponsorObjectId,
        ...(usePaValue ? { usePaValue: 1 } : {}),
        ...(tracked ? { tracked: 1 } : {}),
        ...(rightsholderId > 0 ? { rightsholderId } : {}),
        ...(parentTenantId ? { parentTenantId } : {}),
      },
      method: "GET",
    })
  },
  getSponsorContractCategoryDivded(since, until, sponsorObjectId) {
    return axios({
      url: `${Globals.API_URL}/api/sponsor-contracts/categories`,
      params: { sponsorObjectId, since, until },
      method: "GET",
    })
  },
  getSurveyQuestions() {
    return axios({
      url: `${Globals.API_URL}/api/survey/questions`,
      method: "GET",
    });
  },
  getSegmentQuestionDemographics(questionCode) {
    return axios({
      url: `${Globals.API_URL}/api/survey/segment/metrics/questionDemographics/${questionCode}`,
      method: "GET",
    });
  },
  getSurveyQuestionSubjectDemographics(subjectId) {
    return axios({
      url: `${Globals.API_URL}/api/survey/subject/${subjectId}/demographics`,
      method: "GET",
    });
  },
  getSurveyQuestionOptions(questionId) {
    return axios({
      url: `${Globals.API_URL}/api/survey/${questionId}/options`,
      method: "GET",
    });
  },
  getSurveyQuestionSubjects(questionId) {
    return axios({
      url: `${Globals.API_URL}/api/survey/${questionId}/subjects`,
      method: "GET",
    });
  },
  async getSegmentMetricsByQuestionGroup(params = {}) {
    console.log('Calling API with params:', params);
    return axios({
      url: `${Globals.API_URL}/api/survey/segment/metricsByGroup`,
      method: "POST",
      data: params,
    });
  },
  getSponsorPerformanceTable(since, until, sponsorObjectId) {
    return axios({
      url: `${Globals.API_URL}/api/sponsor-contracts/performance-table?since=${since}&until=${until}`,
      params: { sponsorObjectId },
      method: "GET",
    })
  },
  getSponsorPerformanceBubble(since, until, sponsorObjectId) {
    return axios({
      url: `${Globals.API_URL}/api/sponsor-contracts/performance-bubble?since=${since}&until=${until}`,
      method: "GET",
      params: { sponsorObjectId }
    });
  },
  getAudienceInsightsAthleteRecognition(athleteCode, compareFilters = []) {
    return axios({
      url: `${Globals.API_URL}/api/audience-insights/athlete-recognition`,
      method: 'GET',
      params: {
        athlete: athleteCode,
        compareFilters: JSON.stringify(compareFilters)
      }
    });
  },
  getTenantBrand() {
    return axios({
      url: `${Globals.API_URL}/api/audience-insights/tenant-brand`,
      method: "GET"
    });
  },

  async getLogoDetectionStats(since, until, sponsorObjectId) {
    const params = new URLSearchParams({
      from: since,
      to: until,
      ...(sponsorObjectId && { sponsorObjectId })
    });
    return await axios({
      url: `${Globals.API_URL}/api/logo-detection-stats?${params}`,
      method: "GET",
    });
  },
  getGainedFollowers: async (since, until) => {
    return axios({
      url: `${Globals.API_URL}/api/followers/gained?since=${since}&until=${until}`,
    });
  },

  getTotalFollowers: async (since, until) => {
    return axios({
      url: `${Globals.API_URL}/api/followers?since=${since}&until=${until}`,
    });
  },
  getProjectViews: async (since, until, projectId) => {
    return axios({
      url: `${Globals.API_URL}/api/projects/views`,
      params: {
        since: since,
        until: until,
        projectId,
      }
    });
  },
  getProjectEngagement: async (since, until, projectId) => {
    return axios({
      url: `${Globals.API_URL}/api/projects/engagement`,
      params: {
        since: since,
        until: until,
        projectId,
      }
    });
  },
  getProjectValueDividedYear: async (projectId, since, until) => {
    return axios({
      url: `${Globals.API_URL}/api/projects/value/divided`,
      params: {
        projectId,
        since,
        until,
      }
    });
  },
  getProjectOverview: async (since, until, projectId) => {
    return axios({
      url: `${Globals.API_URL}/api/projects/overview-table`,
      params: {
        projectId,
        since,
        until,
      }
    });
  },
  getDetectionTasks(params = {}) {
    return axios({
      url: `${Globals.API_URL}/api/admin/detection-tasks`,
      method: "GET",
      params: {
        page: params.page || 1,
        per_page: params.per_page || 10,
        confidence_min: params.confidence_min || 0.5,
        brand_id: params.brand_id || '',
        source_name: params.source_name || '',
        status: params.status || '',
        tenant_id: params.tenant_id || '',
        source_type: params.source_type || '',
        source_category: params.source_category || '',
        date_range: params.date_range || ''
      }
    });
  },

  getDetectionTaskSummary(params = {}) {
    return axios({
      url: `${Globals.API_URL}/api/admin/detection-tasks/summary`,
      method: "GET",
      params,
    });
  },

  getAdminEvents(params = {}) {
    return axios({
      url: `${Globals.API_URL}/api/admin/events`,
      method: "GET",
      params,
    });
  },

  getEventBroadcasts(eventId) {
    return axios({
      url: `${Globals.API_URL}/api/admin/events/${eventId}/broadcasts`,
      method: "GET",
    });
  },

  getEventCategories() {
    return axios({
      url: `${Globals.API_URL}/api/admin/events/categories`,
      method: "GET",
    });
  },

  getEventTenants() {
    return axios({
      url: `${Globals.API_URL}/api/admin/events/tenants`,
      method: "GET",
    });
  },

  getEvent(publicId) {
    return axios({
      url: `${Globals.API_URL}/api/admin/events/${publicId}`,
      method: "GET",
    });
  },

  createEvent(data) {
    return axios({
      url: `${Globals.API_URL}/api/admin/events`,
      method: "POST",
      data,
    });
  },

  updateEvent(publicId, data) {
    return axios({
      url: `${Globals.API_URL}/api/admin/events/${publicId}`,
      method: "PUT",
      data,
    });
  },

  deleteEvent(publicId) {
    return axios({
      url: `${Globals.API_URL}/api/admin/events/${publicId}`,
      method: "DELETE",
    });
  },

  getDetectionMedia(taskId) {
    return axios({
      url: `${Globals.API_URL}/api/detection/reviews/${taskId}/detections`,
      method: "GET"
    });
  },

  getTaskDetections(taskId, filters = {}) {
    return axios({
      url: `${Globals.API_URL}/api/detection/reviews/${taskId}/detections`,
      method: "GET",
      params: filters
    });
  },

  createDetectionReview(taskId, reviewData) {
    return axios({
      url: `${Globals.API_URL}/api/detection/reviews/${taskId}`,
      method: "POST",
      data: reviewData
    });
  },

  getDetectionReviewTenants() {
    return axios({
      url: `${Globals.API_URL}/api/detection/reviews/tenants`,
      method: "GET"
    });
  },

  getTvBroadcasts() {
    return axios({
      url: `${Globals.API_URL}/api/admin/tv-broadcasts`,
      method: "GET",
    })
  },

  createVideoMetadata(payload) {
    return axios({
      url: `${Globals.API_URL}/api/admin/video-metadata`,
      method: "POST",
      data: payload,
    })
  },

  createTvBroadcast(payload) {
    return axios({
      url: `${Globals.API_URL}/api/admin/tv-broadcasts`,
      method: 'POST',
      data: payload,
    })
  },

  updateTvBroadcast(publicId, payload) {
    return axios({
      url: `${Globals.API_URL}/api/admin/tv-broadcasts/${publicId}`,
      method: 'PUT',
      data: payload,
    })
  },

  deleteTvBroadcast(publicId) {
    return axios({
      url: `${Globals.API_URL}/api/admin/tv-broadcasts/${publicId}`,
      method: 'DELETE',
    })
  },

  runDetectionTask(publicId) {
    return axios({
      url: `${Globals.API_URL}/api/admin/tv-broadcasts/${publicId}/detect`,
      method: 'POST',
    })
  },

  saveBroadcastExposures(broadcastId, exposures) {
    return axios({
      url: `${Globals.API_URL}/api/admin/tv-broadcasts/${broadcastId}/exposures`,
      method: 'POST',
      data: { exposures }
    })
  },

  getBroadcastExposures(broadcastId) {
    return axios({
      url: `${Globals.API_URL}/api/admin/tv-broadcasts/${broadcastId}/exposures`,
      method: 'GET',
    })
  },

  // Tenant Countries Management
  getCountries() {
    return axios({
      url: `${Globals.API_URL}/api/admin/countries`,
      method: 'GET',
    })
  },

  getTenantCountries(tenantId) {
    return axios({
      url: `${Globals.API_URL}/api/admin/tenants/${tenantId}/countries`,
      method: 'GET',
    })
  },

  updateTenantCountries(tenantId, countries) {
    return axios({
      url: `${Globals.API_URL}/api/admin/tenants/${tenantId}/countries`,
      method: 'PUT',
      data: { countries }
    })
  },

  getTenantFeatures(tenantId) {
    return axios({
      url: `${Globals.API_URL}/api/admin/tenants/${tenantId}/features`,
      method: 'GET',
    })
  },

  updateTenantFeatures(tenantId, features) {
    return axios({
      url: `${Globals.API_URL}/api/admin/tenants/${tenantId}/features`,
      method: 'PUT',
      data: { features }
    })
  },

  // Earned Media
  getEarnedMediaByAccount(since, until) {
    return axios({
      url: `${Globals.API_URL}/api/social/earned/by-account`,
      method: 'GET',
      params: { since, until }
    })
  },

  // Facebook Page Discovery
  searchFacebookPages(query) {
    return axios({
      url: `${Globals.API_URL}/api/facebook/pages/search`,
      method: 'GET',
      params: { q: query }
    })
  },

  // Instagram Account Discovery
  searchInstagram(query) {
    return axios({
      url: `${Globals.API_URL}/api/instagram/search`,
      method: 'GET',
      params: { q: query }
    })
  },

  getTrackedFacebookPages(sponsorObjectId) {
    return axios({
      url: `${Globals.API_URL}/api/facebook/pages/tracked`,
      method: 'GET',
      params: sponsorObjectId ? { sponsor_object_id: sponsorObjectId } : {}
    })
  },

  getTrackedPageDetections(sponsorObjectId) {
    return axios({
      url: `${Globals.API_URL}/api/facebook/pages/tracked/detections`,
      method: 'GET',
      params: sponsorObjectId ? { sponsor_object_id: sponsorObjectId } : {}
    })
  },

  trackFacebookPage(pageId, name, pictureUrl, tenantId, platform, facebookPageId, username) {
    return axios({
      url: `${Globals.API_URL}/api/facebook/pages/track`,
      method: 'POST',
      data: { page_id: pageId, name, picture_url: pictureUrl, tenant_id: tenantId, platform, facebook_page_id: facebookPageId, username }
    })
  },

  untrackFacebookPage(pageId) {
    return axios({
      url: `${Globals.API_URL}/api/facebook/pages/track/${pageId}`,
      method: 'DELETE',
    })
  },

  // ==========================================
  // Sponsor Objects Management
  // ==========================================

  getAdminSponsorObjects(params = {}) {
    return axios({
      url: `${Globals.API_URL}/api/admin/sponsor-objects`,
      method: 'GET',
      params
    })
  },

  getSponsorObject(id) {
    return axios({
      url: `${Globals.API_URL}/api/admin/sponsor-objects/${id}`,
      method: 'GET'
    })
  },

  createSponsorObject(data) {
    return axios({
      url: `${Globals.API_URL}/api/admin/sponsor-objects`,
      method: 'POST',
      data
    })
  },

  updateSponsorObject(id, data) {
    return axios({
      url: `${Globals.API_URL}/api/admin/sponsor-objects/${id}`,
      method: 'PUT',
      data
    })
  },

  deleteSponsorObject(id) {
    return axios({
      url: `${Globals.API_URL}/api/admin/sponsor-objects/${id}`,
      method: 'DELETE'
    })
  },

  getSponsorObjectMappings(sponsorObjectId) {
    return axios({
      url: `${Globals.API_URL}/api/admin/sponsor-objects/${sponsorObjectId}/mappings`,
      method: 'GET'
    })
  },

  saveSponsorObjectMappings(sponsorObjectId, mappings) {
    return axios({
      url: `${Globals.API_URL}/api/admin/sponsor-objects/${sponsorObjectId}/mappings`,
      method: 'PUT',
      data: { mappings }
    })
  },

  getDetectionBrandClasses() {
    return axios({
      url: `${Globals.API_URL}/api/admin/detection-brand-classes`,
      method: 'GET'
    })
  },

  getTenantContracts(tenantId) {
    return axios({
      url: `${Globals.API_URL}/api/admin/tenants/${tenantId}/contracts`,
      method: 'GET'
    })
  },

  getVisualExamples(params = {}) {
    return axios({
      url: `${Globals.API_URL}/api/admin/visual-examples`,
      method: 'GET',
      params
    })
  },

  uploadVisualExample(formData) {
    return axios({
      url: `${Globals.API_URL}/api/admin/visual-examples`,
      method: 'POST',
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  },

  updateVisualExample(id, data) {
    return axios({
      url: `${Globals.API_URL}/api/admin/visual-examples/${id}`,
      method: 'PUT',
      data
    })
  },

  deleteVisualExample(id) {
    return axios({
      url: `${Globals.API_URL}/api/admin/visual-examples/${id}`,
      method: 'DELETE'
    })
  },

  getPlacementAnalysis(params = {}) {
    return axios({
      url: `${Globals.API_URL}/api/admin/placement-analysis`,
      method: 'GET',
      params
    })
  },

  getPlacementAnalysisDetail(videoId, taskId, frameNumber = null) {
    const params = {};
    if (frameNumber !== null) params.frame_number = frameNumber;
    return axios({
      url: `${Globals.API_URL}/api/admin/placement-analysis/${encodeURIComponent(videoId)}/${encodeURIComponent(taskId)}`,
      method: 'GET',
      params
    })
  },

  getPlacementFrames(videoId, taskId) {
    return axios({
      url: `${Globals.API_URL}/api/admin/placement-analysis/${encodeURIComponent(videoId)}/${encodeURIComponent(taskId)}/frames`,
      method: 'GET'
    })
  },

  overridePlacementMapping(data) {
    return axios({
      url: `${Globals.API_URL}/api/admin/placement-analysis/override`,
      method: 'PUT',
      data
    })
  },

  recomputePlacementValue(data) {
    return axios({
      url: `${Globals.API_URL}/api/admin/placement-analysis/recompute-value`,
      method: 'POST',
      data
    })
  },

  getUnmappedPlacements(videoId, taskId) {
    return axios({
      url: `${Globals.API_URL}/api/admin/placement-analysis/${videoId}/${taskId}/unmapped`,
      method: 'GET'
    })
  },

  bulkOverridePlacementMapping(data) {
    return axios({
      url: `${Globals.API_URL}/api/admin/placement-analysis/bulk-override`,
      method: 'PUT',
      data
    })
  },

  getMediaValueSummary(sponsorObjectId, since, until) {
    return axios({
      url: `${Globals.API_URL}/api/sponsors/media-value/summary`,
      method: 'GET',
      params: { sponsorObjectId, since, until }
    })
  },

  getMediaValueTimeline(sponsorObjectId, since, until) {
    return axios({
      url: `${Globals.API_URL}/api/sponsors/media-value/timeline`,
      method: 'GET',
      params: { sponsorObjectId, since, until }
    })
  },

  getMediaValueByEvent(sponsorObjectId, since, until) {
    return axios({
      url: `${Globals.API_URL}/api/sponsors/media-value/by-event`,
      method: 'GET',
      params: { sponsorObjectId, since, until }
    })
  },

  getMediaValueExposures(sponsorObjectId, since, until, page = 1, source = '') {
    return axios({
      url: `${Globals.API_URL}/api/sponsors/media-value/exposures`,
      method: 'GET',
      params: { sponsorObjectId, since, until, page, source }
    })
  },

  // Placement Analysis (ClickHouse sponsor_object_value_daily)
  getPlacementAnalysisRightsholders() {
    return axios({
      url: `${Globals.API_URL}/api/placement-analysis/rightsholders`,
      method: 'GET',
    })
  },

  getPlacementAnalysisSummary(params = {}) {
    return axios({
      url: `${Globals.API_URL}/api/placement-analysis/summary`,
      method: 'GET',
      params,
    })
  },

  getPlacementAnalysisTimeline(params = {}) {
    return axios({
      url: `${Globals.API_URL}/api/placement-analysis/timeline`,
      method: 'GET',
      params,
    })
  },

  getPlacementAnalysisByPlacement(params = {}) {
    return axios({
      url: `${Globals.API_URL}/api/placement-analysis/by-placement`,
      method: 'GET',
      params,
    })
  },

  getPlacementAnalysisByPlacementAttributed(params = {}) {
    return axios({
      url: `${Globals.API_URL}/api/placement-analysis/by-placement-attributed`,
      method: 'GET',
      params,
    })
  },

  getPlacementAnalysisByEvent(params = {}) {
    return axios({
      url: `${Globals.API_URL}/api/placement-analysis/by-event`,
      method: 'GET',
      params,
    })
  },

  getPlacementAnalysisBySponsorObject(params = {}) {
    return axios({
      url: `${Globals.API_URL}/api/placement-analysis/by-sponsor-object`,
      method: 'GET',
      params,
    })
  },

  getPlacementAnalysisValueDrivers(params = {}) {
    return axios({
      url: `${Globals.API_URL}/api/placement-analysis/value-drivers`,
      method: 'GET',
      params,
    })
  },

  getPlacementAnalysisExposureDetail(params = {}) {
    return axios({
      url: `${Globals.API_URL}/api/placement-analysis/exposure-detail`,
      method: 'GET',
      params,
    })
  },

  getPlacementAnalysisValueBySources(params = {}) {
    return axios({
      url: `${Globals.API_URL}/api/placement-analysis/value-by-sources`,
      method: 'GET',
      params,
    })
  },

  getPlacementAnalysisMediaValue(params = {}) {
    return axios({
      url: `${Globals.API_URL}/api/placement-analysis/media-value`,
      method: 'GET',
      params,
    })
  },

  getPlacementAnalysisEngagementValue(params = {}) {
    return axios({
      url: `${Globals.API_URL}/api/placement-analysis/engagement-value`,
      method: 'GET',
      params,
    })
  },

  getPerformingTrackedPosts(params = {}) {
    return axios({
      url: `${Globals.API_URL}/api/social/posts/tracked`,
      method: 'GET',
      params,
    })
  },

  getPlacementAnalysisValueTimeline(params = {}) {
    return axios({
      url: `${Globals.API_URL}/api/placement-analysis/value-timeline`,
      method: 'GET',
      params,
    })
  },

  getPlacementAnalysisTvByChannel(params = {}) {
    return axios({
      url: `${Globals.API_URL}/api/placement-analysis/tv-by-channel`,
      method: 'GET',
      params,
    })
  },

  getPlacementAnalysisReachTimeline(params = {}) {
    return axios({
      url: `${Globals.API_URL}/api/placement-analysis/reach-timeline`,
      method: 'GET',
      params,
    })
  },

  getPlacementAnalysisExposuresTimeline(params = {}) {
    return axios({
      url: `${Globals.API_URL}/api/placement-analysis/exposures-timeline`,
      method: 'GET',
      params,
    })
  },

  getAgentAccess(params = {}) {
    return axios({
      url: `${Globals.API_URL}/api/admin/agent-access`,
      method: 'GET',
      params
    })
  },

  createAgentAccess(data) {
    return axios({
      url: `${Globals.API_URL}/api/admin/agent-access`,
      method: 'POST',
      data
    })
  },

  rotateAgentAccess(id) {
    return axios({
      url: `${Globals.API_URL}/api/admin/agent-access/${id}/rotate`,
      method: 'POST'
    })
  },

  revokeAgentAccess(id) {
    return axios({
      url: `${Globals.API_URL}/api/admin/agent-access/${id}/revoke`,
      method: 'POST'
    })
  },

  createAgentMcpToken(id) {
    return axios({
      url: `${Globals.API_URL}/api/admin/agent-access/${id}/mcp-token`,
      method: 'POST'
    })
  },

  getCpmRates(params = {}) {
    return axios({
      url: `${Globals.API_URL}/api/admin/cpm-rates`,
      method: 'GET',
      params
    })
  },

  createCpmRate(data) {
    return axios({
      url: `${Globals.API_URL}/api/admin/cpm-rates`,
      method: 'POST',
      data
    })
  },

  updateCpmRate(id, data) {
    return axios({
      url: `${Globals.API_URL}/api/admin/cpm-rates/${id}`,
      method: 'PUT',
      data
    })
  },

  deleteCpmRate(id) {
    return axios({
      url: `${Globals.API_URL}/api/admin/cpm-rates/${id}`,
      method: 'DELETE'
    })
  },
};

export default ApiService;